export default __webpack_public_path__ + "static/media/mask8.c4250e3d.jpeg";